import ApiService from '@/services/api.service';

const PatientPortalsService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortals/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    getAllDashboard(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortals/Dashboard',
            headers: {},
            params: parameters,
            paramsSerializer: params => ApiService.parseParams(params)
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortals/${id}`);
    },

    add(data) {
        return ApiService.post(`/PatientPortals`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortals/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortals/${id}`, data);
    },

    createCredentials(data) {
        return ApiService.post(`/PatientPortals/CreateCredentials`, data);
    },

    createAuthLogins(data) {
        return ApiService.post(`/PatientPortals/CreateUserName`, data);
    },

    createLogin(data) {
        return ApiService.post(`/PatientPortals/CreateLogin`, data);
    },

    changePassword(data) {
        return ApiService.post(`/PatientPortals/ChangePassword`, data);
    },

    changeUserName(data) {
        return ApiService.put(`/PatientPortals/ChangeUserName`, data);
    },

    verifyLogin(data) {
        const requestData = {
            method: 'get',
            url: '/PatientPortals/VerifyLogin',
            headers: {},
            params: data
        };
        return ApiService.customRequest(requestData);
    },

    sendNotificationMessage(data) {
        return ApiService.post(`/PatientPortals/SendNotificationMessage`, data);
    }
};

export default PatientPortalsService;
